import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import FFPaper from '../../shared/FFPaper';


export default function PopularTimeCard() {
    return (

        <Grid item={true} xs={12} md={12} lg={2} >
            <FFPaper
                elevation={3}
                sx={{
                    position: 'relative',
                    height: '100%',
                }}
            >
                <Stack sx={{ width: '100%', height: '100%' }}>

                    <Typography color="secondary" sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 36,
                        fontWeight: 600,
                        width: '100%',
                        pt: 4,
                        pb: 1,
                        color: 'text.secondary',
                    }}>3:00 PM</Typography>

                    <Typography sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 22,
                        fontWeight: 600,
                        width: '100%',
                        color: 'primary.main',
                    }}>Most Popular Time</Typography>

                    <Typography sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 16,
                        fontWeight: 600,
                        width: '100%',
                        color: 'text.secondary',
                        pt: 2,
                        pb: 4,
                    }}>vs. 2:00 PM last week</Typography>

                    <Divider light={true} />

                    <Typography color="secondary" sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 36,
                        fontWeight: 600,
                        width: '100%',
                        pt: 3,
                        pb: 1,
                        color: 'text.secondary',
                    }}>5:00 PM</Typography>

                    <Typography sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 22,
                        fontWeight: 600,
                        width: '100%',
                        color: 'primary.main',
                    }}>Secondary Time</Typography>

                    <Typography sx={{
                        verticalAlign: 'middle',
                        textAlign: 'center',
                        display: 'table-cell',
                        fontSize: 16,
                        fontWeight: 600,
                        width: '100%',
                        color: 'text.secondary',
                        pt: 2,
                        pb: {
                            xs: 4,
                            md: 4,
                            lg: 10
                        }
                    }}>vs. 5:45 PM last week</Typography>

                </Stack>
            </FFPaper>
        </Grid>

    )

}
